import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SelectItem } from 'primeng/primeng';

import { ListService } from '../../../shared/service/list.service';
import { CalendarLocale } from '../../../shared/static/calendar-locale';
import { HeaderItemModel } from '../../../shared/model/header-item.model';
import { ConvertDatePipe } from '../../../shared/pipe/convert-date.pipe';
import { ListValueService } from '../../../shared/service/list-value.service';
import { HeaderDefaultModel } from '../../../shared/model/header-default.model';
import { HeaderDefaultService } from '../../../shared/service/header-default.service';
import { HeaderDefaultItemModel } from '../../../shared/model/header-default-item.model';

@Component({
  selector: 'app-header-default-modal',
  templateUrl: './header-default-modal.component.html',
  styleUrls: ['./header-default-modal.component.css']
})
export class HeaderDefaultModalComponent implements OnInit {
  	display: boolean;

	@Output() save = new EventEmitter<any>();
	headerItems: HeaderItemModel[] = [];
	headerDefault: HeaderDefaultModel = new HeaderDefaultModel();
	checklist_id: number;
	calendarLocale = CalendarLocale;

	lists = new Map<number, SelectItem[]>(); 

	constructor(
		private headerDefaultService: HeaderDefaultService, 
		private listValueService: ListValueService,
		private translateService: TranslateService,
		private convertDate: ConvertDatePipe, 
		private listService: ListService, 
	) {	}

	ngOnInit() {
	}

	showModal() {
		this.loadLists();
		this.loadResponses();
	}

	loadResponses() {
		if (this.headerDefault === undefined || this.headerDefault === null) {
			this.headerDefault = new HeaderDefaultModel(this.checklist_id);			
		}

		for (let headerItem of this.headerItems) {
			let found = false;
			
			for (let headerDefaultItem of this.headerDefault.headerDefaultItems) {
				if (headerItem.id === headerDefaultItem.header_item_id) {
					headerDefaultItem.description = headerItem.description;
					found = true;
					break;
				}
			}

			if (!found) {
				this.headerDefault.headerDefaultItems.push(new HeaderDefaultItemModel('', headerItem.header_item_type, headerItem.list_id, headerItem.id, this.headerDefault.id, headerItem.description));
			}
		}
	}

	loadLists() {
		for (let headerItem of this.headerItems) {
			if(headerItem.header_item_type === 5) {
				// Obter lista
				this.listService.findByPk(headerItem.list_id).subscribe(res => {
					let list = [];
					for (let value of res.values) {
						list.push({label: value.description, value: value.id});
					}
					
					this.lists.set(headerItem.list_id, list);
				});
			}
		}
	}

	saveHeaderDefault() {
		// this.headerDefaultService.save(this.headerDefault).subscribe(res => {
		// 	console.log('response', res);
		// 	this.headerDefault.id = res.id;
			
		// });
		this.save.emit(this.headerDefault);
		this.display = false;
	}

	translate = (key: string) => this.translateService.instant(key || "invalid");

	tUpper = (key) => this.translate(key).toString().toUpperCase();
	tCap = (key) =>
    this.translate(key).charAt(0).toUpperCase() + this.translate(key).slice(1);
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/checklist-form/header-default/header-default-modal/header-default-modal.component.ts